import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import Cards3 from './Cards3';
import Feature1 from './CardsImages/feature_1.png'
import Feature2 from './CardsImages/feature_2.png'
import Feature3 from './CardsImages/feature_3.png'
import Feature4 from './CardsImages/feature_4.png'
import { Link } from 'react-router-dom';
import Cards from './Cards';

function Cards2() {
  return (
    <div className='cards'>
      {/* <h1>Kategori Donasi</h1> */}
      <div className='cards__container'>
        <div className='cards__wrapper' >
          <ul className='cards__items'>
            <CardItem
              src={Feature1}
              text='Bantu saudara-saudara yang tengah mengalami kesulitan'
              label='Kemanusiaan'
              path='/kategori-kemanusiaan'
            />
            <CardItem
              src={Feature3}
              text='Demi generasi penerus yang lebih maju'
              label='Pendidikan'
              path='/kategori-pendidikan'
            />
            <CardItem
              src={Feature2}
              text='Sehatlah negeriku'
              label='Kesehatan'
              path='/kategori-kesehatan'
            />
            <CardItem
              src={Feature4}
              text='Ulurkan tangan untuk anak-anak yang kurang beruntung'
              label='Anak'
              path='/kategori-anak'
            />
          </ul>
        </div>
        <div id="category">
          <div className="title-category">
            <h3>Bantuan dari kamu akan sangat berharga untuk mereka</h3>
          </div>
        </div>
        <br />
        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Elit sodales in malesuada parturient facilisis.
          Sagittis, leo, urna turpis libero nisl posuere pretium.
          Morbi sed pellentesque in auctor odio fringilla. Malesuada luctus feugiat risus in.
        </p>
        <button className="btn-2"><Link to="/Pelajari">Pelajari lebih lanjut</Link></button>
        <hr className="line-landing-page" />
        <Cards3 />
        <hr className="line-landing-page" />
        <Cards />
      </div>
    </div>
  );
}

export default Cards2;
